import { KimMessageArtifact } from '../../../../../../../../../../backend/src/matter/subset/thread/kim-message-artifact.entity';

export interface ArtifactGroup {
  latest: KimMessageArtifact;
  versions: KimMessageArtifact[];
}

/** Group artifacts by id, sorted with latest version first within each group. */
export function groupArtifacts(artifacts?: KimMessageArtifact[]): ArtifactGroup[] {
  if (!artifacts) return [];
  const map = new Map<string, KimMessageArtifact[]>();

  for (const artifact of artifacts) {
    const existing = map.get(artifact.id);
    if (existing) {
      existing.push(artifact);
    } else {
      map.set(artifact.id, [artifact]);
    }
  }

  return Array.from(map.values()).map((versions) => {
    const sorted = [...versions].sort((a, b) => b.versionNumber - a.versionNumber);
    return { latest: sorted[0], versions: sorted };
  });
}
